import React, { useMemo } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { propsToDom } from 'core/helpers';
import { useGlobalContext } from 'store/GlobalProvider';
import { Image } from 'components/Image';
import { ContainerGrid } from 'components/Container';
import { Panel } from 'components/Panel';
import media from 'styles/media';

const GalleryComponent = ({ primary, items, slice_type, next_slice_type, ...others }) => {
  const { isMobile } = useGlobalContext();
  const { background } = primary;
  const gallery = useMemo(() => items.filter(({ image }) => !!image?.url), [items]);

  return (
    <Panel {...propsToDom(others)} id={slice_type} nextId={next_slice_type} background={background}>
      <ContainerGrid>
        {gallery.map(({ image, size }, index) => (
          <Image key={index} {...(isMobile ? image.thumbnails.mobile : image)} data-size={size} />
        ))}
      </ContainerGrid>
    </Panel>
  );
};

export const Gallery = styled(GalleryComponent)`
  ${ContainerGrid} {
    grid-row-gap: var(--margin);
  }

  ${Image} {
    position: relative;
    border-radius: 8px;
    overflow: hidden;

    &[data-size='big'] {
      grid-column: 1 / -1;
    }

    &[data-size='small'] {
      grid-column: auto / span 4;
    }
  }

  ${media.mobile`
    ${Image} {
      &[data-size='small'] {
        grid-column: 1 / -1;
      }
    }
  `}
`;

export const query = graphql`
  fragment SliceGalleryHome on PrismicHomeDataBodyGallery {
    id
    slice_type
    primary {
      background
    }
    items {
      image {
        url
        alt
        dimensions {
          width
          height
        }
        thumbnails {
          mobile {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
      size
    }
  }

  fragment SliceGalleryPage on PrismicPageDataBodyGallery {
    id
    slice_type
    primary {
      background
    }
    items {
      image {
        url
        alt
        dimensions {
          width
          height
        }
        thumbnails {
          mobile {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
      size
    }
  }
`;
